// Easing curves for animation keyframes. Each maps a normalised 0..1 progress
// to an eased 0..1 value. Kept small and self-contained; `linear` is the
// default when a keyframe names no easing.

import type { Easing } from "./types";

const EASINGS: Record<Easing, (x: number) => number> = {
  linear: (x) => x,
  easeIn: (x) => x * x,
  easeOut: (x) => 1 - (1 - x) * (1 - x),
  easeInOut: (x) => (x < 0.5 ? 2 * x * x : 1 - Math.pow(-2 * x + 2, 2) / 2),
  sine: (x) => 0.5 - 0.5 * Math.cos(Math.PI * x),
  bounce: (x) => {
    const n1 = 7.5625, d1 = 2.75;
    if (x < 1 / d1) return n1 * x * x;
    if (x < 2 / d1) return n1 * (x -= 1.5 / d1) * x + 0.75;
    if (x < 2.5 / d1) return n1 * (x -= 2.25 / d1) * x + 0.9375;
    return n1 * (x -= 2.625 / d1) * x + 0.984375;
  },
};

/** Apply an easing curve to a normalised 0..1 progress value. */
export function ease(name: Easing | undefined, x: number): number {
  return (EASINGS[name ?? "linear"] ?? EASINGS.linear)(x);
}
